module.exports = __webpack_public_path__ + "static/media/article2.36143d01.jpeg";